// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./tutorial/PageFlag.css
// module id = 2078
// module chunks = 3